var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"num"},[_c('i'),_c('span',[_vm._v(_vm._s(_vm._f("formatNum")((_vm.watchNum + _vm.customWatchNum))))])])
}
var staticRenderFns = []

export { render, staticRenderFns }